import {stopScroll, updateScroll} from '../utilities/locootiveScroll';
import {fixedScroll} from '../utilities/disablescroll';

export function popupLightbox() {
    if ($('.l-equipe__popup').length > 0) {

        const $close = $('.l-equipe__popup button.close, .l-equipe__popup--background');
        const $open = $('[data-membre-id]');

        $open.click(function () {

            stopScroll();
            fixedScroll('enable');

            const POST = {
                id: $(this).attr('data-membre-id'),
            }

            const HOST = location.origin;
            const URL = HOST + '/wp-json/wp/v2/equipe/' + POST.id;

            $.ajax({
                url: URL,
            })
                .done(function (response) {

                    const $content = response.acf.temoignage;
                    const $name = response.acf.prenom + ' ' + response.acf.nom;

                    $('.l-equipe__popup').addClass('js-isActive');
                    $('.l-equipe__popup .name').html($name);
                    $('.l-equipe__popup .content').html($content);
                });
        })

        $close.click(function () {
            $('.l-equipe__popup').removeClass('js-isActive');
            updateScroll();
            fixedScroll('disable');
        })
    }
}

popupLightbox();
